import { adminApiRequest } from "../../utils/apiUtils";

export interface AdminGalleryRequest {
  runnerCompetitionId: number;
  title: string;
  date: Date;
}

export interface AdminSortImageRequest {
  id: number;
  order: number;
}


export const GalleryAPI = {
  getGalleryList: () => {
    return adminApiRequest.get("/gallery/list",).then((res) => res) ;
  },

  getGalleryImageList: (id: number) => {
    return adminApiRequest.get(`/gallery/images/${id}`).then((res) => res);
  },

  registerGallery: (body: FormData) => {
    return adminApiRequest.post("/gallery", body).then((res) => res);
  },

  updateGallery: (id: number, body: FormData) => {
    return adminApiRequest.put(`/gallery/update/${id}`, body).then((res) => res);
  },

  sortGalleryImage: (id: number,body: AdminSortImageRequest[]) => {
    return adminApiRequest.put(`/gallery/sort/${id}`, body).then((res) => res);
  },

  deleteGallery: (id: number) => {
    return adminApiRequest.delete(`/gallery/${id}`).then((res) => res);
  },
  
  deleteGalleryImage: (id: number) => {
    return adminApiRequest.delete(`/gallery/image/${id}`).then((res) => res);
  },
};
